<template>
  <div>
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewJobTitles" v-if="edited == true" >Descartar cambios</b-button>
    <b-button class="float-right" :variant="forceEditSection ? 'outline-danger' : 'danger'" @click="toggleForceEdition" v-if='can("update", "job_titles") && features["update-after-delete"] && deleted' >
      {{ forceEditSection ? 'Cancelar' : 'Editar'}}
    </b-button>
    <b-button class="float-right mr-2" variant="info" v-if="deleted && forceEditSection" @click.prevent="saveChanges">
      Actualizar
    </b-button>

    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Razón social" v-if="(editingState == 'updating' || state=='creating' || forceEditSection) && can('update', 'job_titles')">
          <b-form-select v-model="selectedBusinessName" :options="businessNameOptions"
          >  
          </b-form-select>
          <b-form-select v-model="selectedBranch" :options="branchesOptions"
          >
          </b-form-select>
        </b-form-group>
        <span v-else-if="businessName" v-b-tooltip.hover :title="branch.name">
          Razón social: <b-badge class="success">
            {{ businessName.name}}
          </b-badge>
        </span>
        <span v-else>
          <b-badge variant="danger">Sin razón social</b-badge>
        </span>
      </div>

      <div class="col-md-6">
        <b-form-group label="Kardex" v-if="(editingState == 'updating' || state=='creating')">
          <b-form-select v-model="selectedKardex" :options="kardexOptions"
          >  
          </b-form-select>
        </b-form-group>
        <span v-else-if="kardexEmployee">
          Area: <b-badge variant="success">
            {{ kardexEmployee.name}}
          </b-badge>
        </span>
        <span v-else>
          <b-badge variant="danger">Sin kardex asignado</b-badge>
        </span>
      </div>
    </div>

    <div class="row" v-if='features["job-positions"]'>
      <div class="col-md-6">
        <b-form-group label="Puesto real" v-if="(editingState == 'updating' || forceEditSection)">
          <b-form-select v-model="selectedJobPosition" :options="jobPositionOptions" @change="getBranchesOfBusinessName($event, selectedJobPosition)"
          >
          </b-form-select>
        </b-form-group>
        <span v-else-if="jobPosition">
          Puesto real: <b-badge class="primary">
            {{ jobPosition.name}}
          </b-badge>
        </span>
        <span v-else-if="!jobPosition && !((editingState == 'updating' || (editingState == 'creating')) && can('update', 'job_titles'))">
          <b-badge variant="danger">Sin puesto real asignado</b-badge>
        </span>
      </div>
    </div>

    <div class="mb-3">
      <b-button v-if="editingState == 'updating' && can('update', 'job_titles')" @click="isStacked = !isStacked">
        {{ isStacked ? 'Ver en forma de tabla' : 'Ver en forma de lista' }}
      </b-button>
    </div>
    <b-table v-if="jobTitles.length>0" :fields="jobTitleFields" :items="jobTitles" :stacked="(editingState == 'updating' && can('update', 'job_titles') && isStacked) ||  'md'" responsive hover striped>
      <template #cell(effective_date)="data">
        <b-form-input type="date"
          :value="data.item.effective_date"
          @input="updateJobTitleDate($event, data.item.pivot)"
          v-if="editingState == 'updating' && can('update', 'job_titles')"
          >
        </b-form-input>
        <span v-if="editingState != 'updating' || !can('update', 'job_titles')">
          {{ data.item.effective_date }}
        </span>
      </template>
      <template #cell(actions)="data">
        <b-button size="sm" :variant="data.item.deleted ? 'secondary' : 'danger'" v-if="editingState =='updating' && can('delete', 'job_titles')" @click="deleteJobTitle(data.item.pivot)">
          {{ data.item.deleted ? 'No eliminar' : 'Eliminar' }}
        </b-button>
      </template>
    </b-table>
    <b-button variant="link" v-if="state=='show'&&can('create', 'job_titles')&&!deleted" @click="create">Otro puesto</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Empresa">  
        <b-form-select v-model="selectedEnterprise" :options="enterpriseOptions"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Área">  
        <b-form-select v-model="selectedArea" :options="areaOptions"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Departamento">  
        <b-form-select v-model="selectedDepartment" :options="departmentOptions"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Puesto">  
        <b-form-select v-model="selectedJobTitle" :options="jobTitleOptions"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="A partir del">  
        <b-form-input v-model="effectiveDate" type="date"></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
import EmployeeControl from './EmployeeControl.vue';
export default{
  components: {
    EmployeeControl  
  },
  data (){
    return {
      forceEditSection: false,
      selectedEnterprise: null,
      selectedArea: null,
      selectedDepartment: null,
      selectedJobTitle: null,
      effectiveDate: '',
      jobTitleFields: [
        {
          key: 'enterprise',
          label: 'Empresa'
        },
        {
          key: 'area',
          label: 'Área'
        },
        {
          key: 'department',
          label: 'Departamento'
        },
        {
          key: 'name',
          label: 'Nombre',
        },
        {
          key: 'description',
          label: 'Descripción',
        },
        {
          key: 'effective_date',
          label: 'A partir del',
          sortable: true
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      isStacked: false,
      currentJobPositions: [],
    }
  },
  methods: {
    toggleForceEdition (){
      this.forceEditSection = !this.forceEditSection
    },
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },

    ...mapActions(['resetNewJobTitles', 'saveChanges']),
    ...mapMutations({
      updateJobTitle: 'updateNewJobTitleAttribute',
      create: 'creatingJobTitle',
      updateEmployeeJobTitle: 'updateEmployeeJobTitle',
      updateBusinessName: 'updateBusinessName',
      updateBranch: 'updateBranch',
      updateJobPosition: 'updateJobPosition',
      deleteEmployeeJobTitle: 'deleteEmployeeJobTitle',
      updateKardex: 'updateKardex'
    }),
    addIfValid (){
      var validation = this.valid()

      if(validation.valid){
        this.$store.dispatch('addJobTitle', {
          enterprise: this.enterprise,
          area: this.area,
          department: this.department,
          jobTitle: this.jobTitle,
          effectiveDate: this.effectiveDate,
        });
        // this.updateBusinessName(this.businessName);
        // this.selectedBusinessName = null;
        this.selectedDepartment = null
        this.selectedJobTitle = null
        this.effectiveDate = null
      }
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.selectedJobTitle!==null, 'Debes escoger un puesto')
      validator.rule(
        this.effectiveDate!='', 'Debes de escoger una fecha a partir de la cuál el empleado tiene el puesto')
      return validator.validate()
    },
    updateJobTitleDate(date, pivot) {
      this.updateEmployeeJobTitle({date, pivot});
    },
    deleteJobTitle(jobTitle) {
      this.deleteEmployeeJobTitle(jobTitle);
    }
  },
  watch: {
    selectedEnterprise(){
      this.selectedArea = null     
      this.selectedDepartment = null
      this.selectedJobTitle = null
    },
    selectedArea(){
      this.selectedDepartment = null
      this.selectedJobTitle = null
    },
    selectedDepartment(){
      this.selectedJobTitle = null
    },
    forceEditSection(newv, oldv){
      console.log(newv, this)
      if(newv) {
        //then fill out the business name, branch and job position
        // this.updateBusinessName(this.businessName);
        // this.updateBranch(this.branch);
        // this.updateJobPosition(this.jobPosition);
      }
    },
  },
  computed: {
    ...mapGetters({
      edited: 'jobTitleEdited',
      jobTitlesCount: 'jobTitlesCount',
      activePayrollConfigCount: 'activePayrollConfigCount'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      jobTitles: state=>state.employeeManager.employee.jobTitles,
      jobPositions: state=>state.employeeManager.employee.jobPositions,
      state: state=>state.employeeManager.jobTitleState,
      enterprises: state=>state.employeeManager.enterprises,
      editingState: state => state.employeeManager.state,
      businessNames: state => state.employeeManager.businessNames,
      branches: state => state.employeeManager.branches,
      jobPositionsCatalog: state => state.employeeManager.jobPositionsCatalog,
      jobPositionId: state => state.employeeManager.employee.job_position_id,
      businessNameId: state => state.employeeManager.employee.business_name_id,
      branchId: state => state.employeeManager.employee.branch_id,
      kardexId: state => state.employeeManager.employee.kardex_id,
      kardex: state => state.employeeManager.kardex,
      features: state => state.employeeManager.features,
      deleted_at: state=>state.employeeManager.employee.deleted_at,
    }),
    kardexOptions() {
      return [{ value: null, text: 'Seleccionar lista de asistencia' }].concat(this.kardex.map(k => {
        return {
          value: k.id,
          text: k.name
        };
      }))
    },
    enterpriseOptions(){
      return this.enterprises.map(e=>{
        return {
          value: e.id, text: e.name
        }
      }).concat([{value: null, text:'--Seleccionar empresa--'}])
    },
    jobPositionOptions() {
        this.jbf = this.jobPositionsCatalog.filter((jp) => {
            return jp.business_names.find(e => e.id == this.businessNameId);
        } );
        return [{ value: null, text: 'Seleccionar puesto real' }].concat(this.jbf.map(k => {
            return {
                value: k.id,
                text: k.name
            };
        }))
    },
    businessNameOptions() {
      return this.businessNames.map(e => {
        return {
          value: e.id, text: e.name
        }
      }).concat([{ value: null, text: '--Seleccionar razón social--' }])
    },
    branchesOptions() {
      return this.branches.map(e => {

        return {
          value: e.id, text: e.name
        }
      }).concat([{ value: null, text: '--Seleccionar sucursal--' }])
    },
    enterprise(){
      if(this.selectedEnterprise===null) return null
      return this.enterprises.find(e=>e.id==this.selectedEnterprise)
    },
    availableAreas(){
      if(this.enterprise===null) return []
      return this.enterprise.areas
    },
    areaOptions(){
      return this.availableAreas.map(a=>{
        return {
          value: a.id, text: a.name
        }
      }).concat([{value: null, text:'--Seleccionar área--'}])
    },
    area(){
      if(this.selectedArea===null) return null
      return this.availableAreas.find(a=>a.id==this.selectedArea)
    },
    availableDepartments(){
      if(this.area===null) return []
      return this.area.departments
    },
    departmentOptions(){
      return this.availableDepartments.map(d=>{
        return {
          value: d.id, text: d.name
        }
      }).concat([{value: null, text:'--Seleccionar departamento--'}])
    },
    department(){
      if(this.selectedDepartment===null) return null
      return this.availableDepartments.find(d=>d.id==this.selectedDepartment)
    },
    businessName() {
      return this.businessNames.find(o => o.id == this.businessNameId);
    },
    branch() {
      console.error(this.branches, this.branchId)
      return this.branches.find(o => o.id == this.branchId);
    },
    selectedBusinessName: {
      get() {
        return this.businessNameId
      },
      set(newVal) {
        this.updateBusinessName(newVal);
      }
    },
    selectedBranch: {
      get() {
        return this.branchId
      },
      set(newVal) {
        this.updateBranch(newVal);
      }
    },
    jobPosition() {
        if(this.jobPositions && ! this.currentJobPositions.length)//
            return this.jobPositions.length?this.jobPositions[0]:null;
        else if (this.currentJobPositions.length)
            return this.currentJobPositions[this.currentJobPositions.length - 1];
        return null
    },
    selectedJobPosition: {
        get() {
            return this.jobPositionId
        },
        set(newVal) {
            this.updateJobPosition(newVal);
        }
    },
    kardexEmployee() {
      return this.kardex.find(k => k.id == this.kardexId)
    },
    selectedKardex: {
      get() {
        return this.kardexId
      },
      set(newVal) {
        this.updateKardex(newVal);
      }
    },
    employments(){
      if(this.department===null) return []
      return this.department.employments
    },
    jobTitleOptions(){
      return this.employments.map(j=>{
        return {
          value: j.id, text: j.name
        }
      }).concat([{value: null, text:'--Seleccionar puesto--'}])
    },
    jobTitle(){
      if(this.selectedJobTitle===null) return null
      return this.employments.find(j=>j.id==this.selectedJobTitle)
    },
    deleted() {
      return this.deleted_at !== null;
    }
  }
  ,
  mounted() {
    console.log(this)
  }
}
</script>

